import type { FilterDefault } from 'next-sanity';
import { createBaseClient, createNoCdnClient } from '@workspace/sanity-base/lib';
import { apiVersion, dataset, projectId, studioUrl } from './api';
import { token } from './token';

const clientConfig = {
  projectId,
  dataset,
  apiVersion,
  token,
  stegaFilter: (props: Parameters<FilterDefault>[0]) => {
    if (String(props.sourcePath.at(-1)) === 'title') {
      return true;
    }
    return props.filterDefault(props);
  },
  studioUrl,
};

export const client = createBaseClient(clientConfig);
export const noCdnClient = createNoCdnClient(clientConfig);
